import {useContext} from 'react';
import {ThemeContext} from '../../utils/ThemeContext';

const ServicesHeroSvg2Mobile = () => {
  const {theme} = useContext(ThemeContext);
  const linearGradientID = theme === 'dark' ? 'url(#paint5)' : 'url(#paint6)';

  const svgContainerStyle = {
    position: 'absolute',
    left: 'calc(50% - 145px)',
    top: 'calc(50% + 156px)',
    width: '156',
    height: '50'
  };
  const pathStyle = {
    strokeDasharray: '1200',
    strokeDashoffset: '1200',
    animation: 'draw 2s ease-in-out forwards',
    animationDelay: '1s',
    stroke: linearGradientID,
    strokeWidth: '1',
    strokeLinecap: 'round'
  };

  return (
    <div style={svgContainerStyle}>
      <svg width='156' height='50' viewBox='0 0 156 50' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M1 1C36.528 29.1065 90.1244 49 154.982 49' style={pathStyle} />
        <defs>
          <linearGradient id='paint5' x1='107.003' y1='54.6578' x2='24.2329' y2='-35.3379' gradientUnits='userSpaceOnUse'>
            <stop stopColor='#2463AC' />
            <stop offset='1' stopColor='#A3CDFF' stopOpacity='0' />
          </linearGradient>
          <linearGradient id='paint6' x1='107.003' y1='54.6578' x2='24.2329' y2='-35.3379' gradientUnits='userSpaceOnUse'>
            <stop stopColor='#FE7518' />
            <stop offset='1' stopColor='#FE7518' stopOpacity='0' />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};

export default ServicesHeroSvg2Mobile;

